<main class="content">
  <h2 class="fw-light" *ngIf="requestType !== requestTypeEnum.leasing">
    {{ 'additionalInfoTitle' | i18next }}
  </h2>
  <h2 class="fw-light" *ngIf="requestType === requestTypeEnum.leasing">
    {{ 'reviewData' | i18next }}
  </h2>
  <form [formGroup]="form" style="width: 100%; max-width: 880px">
    <div
      *ngIf="requestType !== requestTypeEnum.leasing"
      style="position: relative"
    >
      <app-additional-info-petitioner
        id="addInfo"
        *ngIf="
          requestType !== 'bookVehicle' &&
          requestType !== 'PROJECT' &&
          requestType !== 'E-S'
        "
        (dataChange)="onDataChange($event)"
        (additionalDataErrorEmitter)="onAdditionalDataError($event)"
      ></app-additional-info-petitioner>
      <small *ngIf="additionalInfoError" class="error-message">{{
        'errWrongPattern' | i18next
      }}</small>
    </div>
    <section
      *ngIf="substitutionVehicle"
      class="d-flex flex-column gap-2 mb-4 col-12 col-md-6"
    >
      <h5 class="content--box__title">
        {{ 'aboutReplacedVehicle' | i18next }}
      </h5>
      <div class="d-flex flex-column flex-md-row justify-content-between gap-4">
        <div class="d-flex flex-column gap-1 col-12 col-md-5">
          <span class="lead text-truncate">{{
            substitutionVehicle.model | valueData
          }}</span>
          <span>{{ substitutionVehicle.plateNumber | valueData }}</span>
        </div>
        <div class="d-flex flex-column gap-1 col-12 col-md-6">
          <label for="estimatedKms">{{ 'kilometers' | i18next }}*</label>
          <input
            id="estimatedKms"
            class="primary-input"
            placeholder="29024"
            formControlName="estimatedKms"
            type="number"
            (change)="changeEstimatedKms()"
          />
          <mat-error
            *ngIf="form.get('estimatedKms')?.hasError('decimalNotAllowed')"
          >
            {{ 'integerRequired' | i18next }}
          </mat-error>
        </div>
      </div>
    </section>
    <section
      *ngIf="requestType === requestTypeEnum.function"
      class="d-flex flex-column gap-2 mb-4 col-12 col-md-6"
    >
      <h5 class="content--box__title">
        {{ 'retribution' | i18next }}
      </h5>
      <div class="d-flex flex-column flex-md-row justify-content-between gap-4">
        <div class="d-flex flex-column gap-1 col-12 col-md-5">
          <span [class.text-danger]="retribution === ''">{{
            retributionText
          }}</span>
        </div>
      </div>
    </section>
    <!-- Observaciones -->
    <section class="content--box">
      <div *ngIf="requestType !== requestTypeEnum.leasing">
        <h5 class="content--box__title">
          {{ 'stepComments' | i18next }}
        </h5>
        <div class="d-flex flex-column gap-1">
          <label for="comments">{{ 'observations' | i18next }}</label>
          <textarea
            class="primary-input textarea"
            formControlName="comments"
            name="comments"
            rows="2"
            [placeholder]="'commentsPlaceholder' | i18next"
          ></textarea>
        </div>
      </div>
      <div
        class="error"
        *ngIf="validationError && form.controls['estimatedKms'].valid"
      >
        <p>{{ 'errorRequest' | i18next }}</p>
        <p *ngIf="tmaimgMonths">
          {{ 'errorVehicle' | i18next: { months: tmaimgMonths } }}
        </p>
        <p *ngIf="tmaimgKms">
          {{ 'errorDate' | i18next: { kms: tmaimgKms } }}
        </p>
      </div>
      <div
        class="d-flex flex-column gap-1 my-2"
        *ngIf="
          isCheckboxOptional &&
          requestType !== requestTypeEnum.leasing &&
          requestType !== requestTypeEnum.es
        "
      >
        <mat-checkbox
          class="checkbox"
          color="primary"
          formControlName="deliveryLocationChecked"
        >
          {{ 'deliveryLocationText' | i18next }}</mat-checkbox
        >
      </div>
      <div
        class="content--box__item"
        *ngIf="
          requestType === requestTypeEnum.loan && loanType !== loanOptions.CP
        "
      >
        <mat-checkbox
          class="checkbox"
          name="moreThanOneVehicle"
          id="moreThanOneVehicle"
          formControlName="moreThanOneVehicle"
          color="primary"
          >{{ 'requestMoreVehicles' | i18next }}</mat-checkbox
        >
      </div>
      <div
        class="d-flex flex-row gap-1 my-2"
        *ngIf="requestType === requestTypeEnum.leasing"
      >
        <mat-checkbox
          class="checkbox"
          name="emailCheck"
          id="emailCheck"
          formControlName="emailCheck"
          color="primary"
          >{{ 'textEmailCheck' | i18next }}</mat-checkbox
        >
        <mat-icon [matTooltip]="userTooltip">info_outline</mat-icon>
      </div>
      <div
        class="d-flex flex-row gap-1 my-2"
        *ngIf="requestType === requestTypeEnum.leasing"
      >
        <mat-checkbox
          class="checkbox"
          name="leasing"
          id="leasing"
          formControlName="leasing"
          color="primary"
          >{{ 'textLeasingCheck' | i18next }}</mat-checkbox
        >
        <mat-icon [matTooltip]="'specialCompensationText' | i18next"
          >info_outline</mat-icon
        >
      </div>
      <a
        *ngIf="requestType === requestTypeEnum.leasing"
        href="https://sem-es-seat.my.salesforce.com/sfc/p/7Q000000K9AF/a/W7000001W4G1/0hqTXGLV6YjEHygAPdiEVwrqzwAkZCcJWHjQY1qBH_s"
        target="_blank"
        style="
          color: rgb(23, 43, 77);
          font-size: 14px;
          background-color: rgb(255, 255, 255);
          margin-left: 44px;
        "
        ><strong><u>Pliego de condiciones</u></strong></a
      >
    </section>
  </form>
  <div class="content--btnContainer">
    <button
      class="content--btnContainer__btn"
      mat-button
      [disabled]="
        isButtonDisabled() ||
        additionalInfoError ||
        form.get('estimatedKms')?.hasError('decimalNotAllowed') ||
        validationError
      "
      [style]="getButtonStyle()"
      (click)="sendRequest()"
    >
      {{ 'buttonContinue' | i18next | uppercase }}
    </button>
    <button
      class="content--btnContainer__btn content--btnContainer__btn__back"
      [style]="
        'background-color: #2c2a29; display: flex; align-items: center; gap: 0.5rem'
      "
      mat-button
      (click)="backStep()"
    >
      <mat-icon class="icon">arrow_back</mat-icon>
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</main>
